const background = document.querySelector('[data-kb-background]');

if (background) {
  const imageLayer = background.querySelector('.kb-background-layer--image');
  const videoLayers = [...background.querySelectorAll('[data-kb-background-video]')];
  videoLayers.forEach((video) => {
    video.muted = true;
    video.volume = 0;
  });
  const mobileQuery = window.matchMedia('(max-width: 700px)');
  const landingStages = [
    { image: true, duration: 2000 },
    { video: 0, duration: 5000 },
    { video: 1, duration: 3000 },
    { video: 2, duration: 5000 },
  ];
  let stageTimer;
  let stageIndex = 0;
  let sequence = [];
  let preloadGeneration = 0;
  let activeVideoIndex = 0;
  const videoCache = new Map();

  const getAsset = (name) => background.dataset[name];
  const getLandingImage = () => (mobileQuery.matches ? getAsset('mobileLandingImage') : getAsset('desktopLandingImage'));
  const getLandingLoop = () => (mobileQuery.matches ? getAsset('mobileLoop') : getAsset('desktopLoop'));
  const getLandingSequence = () => (mobileQuery.matches ? getAsset('mobileSequence') : getAsset('desktopSequence')).split('|');

  const clearStageTimer = () => window.clearTimeout(stageTimer);

  const preloadVideo = (url) => {
    if (videoCache.has(url)) return videoCache.get(url);

    const video = document.createElement('video');
    video.muted = true;
    video.volume = 0;
    video.preload = 'auto';
    video.playsInline = true;
    video.src = url;
    video.load();
    const ready = new Promise((resolve) => {
      if (video.readyState >= 2) {
        resolve(video);
      } else {
        video.addEventListener('loadeddata', () => resolve(video), { once: true });
      }
    });
    videoCache.set(url, ready);
    return ready;
  };

  const revealVideoFrame = (video) => {
    video.currentTime = 0;
    if (typeof video.requestVideoFrameCallback === 'function') {
      return new Promise((resolve) => video.requestVideoFrameCallback(resolve));
    }
    return new Promise((resolve) => window.setTimeout(resolve, 80));
  };

  const showLandingStage = async () => {
    clearStageTimer();
    const stage = landingStages[stageIndex];
    const generation = preloadGeneration;
    imageLayer.style.backgroundImage = `url("${getLandingImage()}")`;

    if (stage.image) {
      background.classList.remove('is-video-active');
    } else {
      const source = sequence[stage.video];
      await preloadVideo(source);
      if (generation !== preloadGeneration || stageIndex !== landingStages.indexOf(stage)) return;
      const nextVideoIndex = activeVideoIndex === 0 ? 1 : 0;
      const nextVideo = videoLayers[nextVideoIndex];
      nextVideo.src = source;
      nextVideo.load();
      await new Promise((resolve) => {
        if (nextVideo.readyState >= 2) {
          resolve();
        } else {
          nextVideo.addEventListener('loadeddata', resolve, { once: true });
        }
      });
      await revealVideoFrame(nextVideo);
      if (generation !== preloadGeneration) return;
      nextVideo.classList.add('is-visible');
      background.classList.add('is-video-active');
      nextVideo.play().catch(() => {});
      const previousVideo = videoLayers[activeVideoIndex];
      previousVideo.classList.remove('is-visible');
      previousVideo.pause();
      activeVideoIndex = nextVideoIndex;
    }

    stageTimer = window.setTimeout(() => {
      stageIndex = (stageIndex + 1) % landingStages.length;
      showLandingStage();
    }, stage.duration);
  };

  const showStaticBackground = (imageKey) => {
    preloadGeneration += 1;
    clearStageTimer();
    background.classList.remove('is-video-active');
    videoLayers.forEach((video) => {
      video.classList.remove('is-visible');
      video.pause();
      video.removeAttribute('src');
      video.load();
    });
    imageLayer.style.backgroundImage = `url("${getAsset(imageKey)}")`;
  };

  const showLandingLoop = async (source) => {
    const generation = preloadGeneration;
    await preloadVideo(source);
    if (generation !== preloadGeneration) return;
    const nextVideoIndex = activeVideoIndex === 0 ? 1 : 0;
    const nextVideo = videoLayers[nextVideoIndex];
    nextVideo.src = source;
    nextVideo.loop = true;
    nextVideo.load();
    await new Promise((resolve) => {
      if (nextVideo.readyState >= 2) resolve();
      else nextVideo.addEventListener('loadeddata', resolve, { once: true });
    });
    await revealVideoFrame(nextVideo);
    if (generation !== preloadGeneration) return;
    nextVideo.classList.add('is-visible');
    background.classList.add('is-video-active');
    nextVideo.play().catch(() => {});
    const previousVideo = videoLayers[activeVideoIndex];
    previousVideo.classList.remove('is-visible');
    previousVideo.pause();
    activeVideoIndex = nextVideoIndex;
  };

  const updateBackground = () => {
    const mode = background.dataset.kbBackgroundMode;
    if (mode === 'landing') {
      preloadGeneration += 1;
      const landingLoop = getLandingLoop();
      if (landingLoop) {
        imageLayer.style.backgroundImage = `url("${getLandingImage()}")`;
        showLandingLoop(landingLoop);
        return;
      }
      sequence = getLandingSequence();
      sequence.forEach((source) => preloadVideo(source));
      stageIndex = 0;
      showLandingStage();
    } else if (mode === 'product') {
      showStaticBackground(mobileQuery.matches ? 'mobileProductImage' : 'desktopProductImage');
    } else {
      showStaticBackground('aboutImage');
    }
  };

  mobileQuery.addEventListener('change', updateBackground);
  updateBackground();
}

document.querySelectorAll('[data-kb-carousel]').forEach((carousel) => {
  const slides = [...carousel.querySelectorAll('[data-kb-slide]')];
  let currentIndex = 0;
  let rotation;

  if (slides.length < 2) return;

  const showSlide = (nextIndex) => {
    slides[currentIndex].classList.remove('is-active');
    currentIndex = (nextIndex + slides.length) % slides.length;
    slides[currentIndex].classList.add('is-active');
  };
  const startRotation = () => {
    window.clearInterval(rotation);
    rotation = window.setInterval(() => showSlide(currentIndex + 1), 5000);
  };

  carousel.querySelector('[data-kb-previous]').addEventListener('click', () => { showSlide(currentIndex - 1); startRotation(); });
  carousel.querySelector('[data-kb-next]').addEventListener('click', () => { showSlide(currentIndex + 1); startRotation(); });
  carousel.addEventListener('mouseenter', () => window.clearInterval(rotation));
  carousel.addEventListener('mouseleave', startRotation);
  startRotation();
});

const sizeChart = document.querySelector('[data-kb-size-chart]');

if (sizeChart) {
  const openButton = document.querySelector('[data-kb-size-chart-open]');
  const closeButtons = sizeChart.querySelectorAll('[data-kb-size-chart-close]');

  const closeSizeChart = () => {
    sizeChart.hidden = true;
    openButton.focus();
  };

  openButton.addEventListener('click', () => {
    sizeChart.hidden = false;
    sizeChart.querySelector('.kb-size-chart-close').focus();
  });
  closeButtons.forEach((button) => button.addEventListener('click', closeSizeChart));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !sizeChart.hidden) closeSizeChart();
  });
}

const productGallery = document.querySelector('.kb-product-gallery--mobile');

productGallery?.querySelectorAll('[data-kb-product-thumbnail]').forEach((thumbnail) => {
  thumbnail.addEventListener('click', (event) => {
    event.preventDefault();
    const mainImage = productGallery.querySelector('#kb-mobile-main-image, .kb-product-mobile-main-image');
    if (!mainImage) return;
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = thumbnail.dataset.fullImage;
    productGallery.querySelectorAll('[data-kb-product-thumbnail]').forEach((item) => item.classList.remove('is-active'));
    thumbnail.classList.add('is-active');
  });
});

const navToggle = document.querySelector('[data-kb-nav-toggle]');
const cornerMenu = document.querySelector('[data-kb-corner-menu]');

if (navToggle && cornerMenu) {
  const closeNavigation = () => {
    cornerMenu.hidden = true;
    navToggle.setAttribute('aria-expanded', 'false');
  };

  navToggle.addEventListener('click', () => {
    cornerMenu.hidden = !cornerMenu.hidden;
    navToggle.setAttribute('aria-expanded', String(!cornerMenu.hidden));
    if (!cornerMenu.hidden) cornerMenu.querySelector('.kb-corner-menu__close').focus();
  });
  cornerMenu.querySelectorAll('[data-kb-nav-close]').forEach((element) => element.addEventListener('click', closeNavigation));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !cornerMenu.hidden) closeNavigation();
  });
}

